import { routes } from "@constants/routes";
import { EducationForm, EducationTable, useResumeStore, UserTypeEnum } from "@cpj-ai/panel-npm-package";
import { useGetEducationInfoByIdLazyQuery, useGetEducationsQuery } from "@graphql/generated";
import { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";

export type TEducationState = "TABLE" | "FORM";

const EducationTabContent = () => {
  const params = useParams();
  const [educationState, setEducationState] = useState<TEducationState>("TABLE");
  const location = useLocation();
  const { setEducationEditId } = useResumeStore();
  const { data, refetch, loading } = useGetEducationsQuery({ variables: { id: Number(params.id) } });
  const [getEducationInfoById, { data: educationInfo, loading: getEducationInfoLoading }] =
    useGetEducationInfoByIdLazyQuery();
  useEffect(() => {
    setEducationEditId(undefined);
  }, [setEducationEditId]);

  return (
    <div>
      {educationState === "TABLE" ? (
        <EducationTable
          setEducationState={setEducationState}
          educationState={educationState}
          handleNextTab={() => {}}
          data={data?.admin?.jobSeekers?.edges[0]?.node?.educations}
          loading={loading}
          refetch={refetch}
          showAddNewSection={false}
        />
      ) : (
        <EducationForm
          setEducationState={setEducationState}
          supportUrl={routes.support.main}
          pathname={location.pathname}
          getEducationInfoById={getEducationInfoById}
          educationInfo={educationInfo?.admin?.education}
          getEducationInfoLoading={getEducationInfoLoading}
          userType={UserTypeEnum.ADMIN}
        />
      )}
    </div>
  );
};

export default EducationTabContent;
